import React from 'react'
import { useTranslation } from 'react-i18next'

import ThermalPrint, { ThermalPrintButton, useThermalPrint } from 'pages/parts/ThermalPrint'

import { formatMoney, formatDate } from 'helpers/helpers'

function Index({ showRightBar, setShowRightBar, data }) {
	const { t } = useTranslation()
	const { printRef, handlePrint } = useThermalPrint()

	return (
		<>
			<div className="right-sidebar-background" onClick={() => setShowRightBar(!showRightBar)}></div>
			<div className="right-sidebar p-2">
				<div className="position-relative">
					<div className="px-2"
						style={{
							position: 'absolute',
							top: '0',
							right: '0',
							zIndex: 2,
						}}>
						<ThermalPrintButton onClick={handlePrint} />
					</div>

					<h4 className="fw-600 pe-5">{t('document_from')} {formatDate(data.created_at, 'dd.MM.yy HH:mm')}</h4>
					<div className="flex-column preview-info">
						<div className="d-flex gap-2">
							<div className="fw-600">{t('pos')}:</div>
							<div>{data.pos_name}</div>
						</div>
						<div className="d-flex gap-2">
							<div className="fw-600">{t('from_warehouse')}:</div>
							<div>{data.wms_name}</div>
						</div>
						<div className="d-flex gap-2">
							<div className="fw-600">{t('external_pos')}:</div>
							<div>{data.to_pos_name}</div>
						</div>
						<div className="d-flex gap-2">
							<div className="fw-600">{t('external_wms')}:</div>
							<div>{data.to_wms_name}</div>
						</div>
						<div className="d-flex gap-2">
							<div className="fw-600">{t('note')}:</div>
							<div>{data.note}</div>
						</div>
					</div>

					<div className="table-responsive">
						<table className="table table-bordered">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '40%' }}>{t('name2')}</th>
									<th style={{ 'width': '10%' }} className="td-ellipsis text-end text-nowrap" title={t('quantity')}>{t('quantity')}</th>
									<th style={{ 'width': '10%' }} className="td-ellipsis text-end text-nowrap" title={t('unit')}>{t('unit')}</th>
									<th style={{ 'width': '20%' }} className="td-ellipsis text-end text-nowrap" title={t('price')}>{t('sale_price')}</th>
									<th style={{ 'width': '20%' }} className="td-ellipsis text-end">{t('amount')}</th>
								</tr>
							</thead>
							<tbody>
								{data?.items?.map((item, index) => (
									<tr key={index}>
										<td className={`text-center ${item.status === -1 ? 'bg-danger text-white' : ''}`} title={item.id}>
											{index + 1}
										</td>
										<td className="td-ellipsis" title={item.element_id}>{item.name}</td>
										<td className="text-end text-nowrap">{formatMoney(item.quantity, 2)}</td>
										<td>{item.unit_name}</td>
										<td className="text-end text-nowrap">{formatMoney(item.sale_price)}</td>
										<td className="text-end text-nowrap">{formatMoney(item.quantity * item.sale_price)}</td>
									</tr>
								))}
								<tr>
									<td></td>
									<td><b>{t('total')}</b></td>
									<td className="text-end text-nowrap">
										<b>{formatMoney(data?.overall_quantity)}</b>
									</td>
									<td></td>
									<td></td>
									<td className="text-end"><b>{formatMoney(data.overall_amount)}</b></td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>

			<ThermalPrint
				printRef={printRef}
				title={`${t('document_from')} ${formatDate(data.created_at, 'dd.MM.yy HH:mm')}`}
				info={[
					{ label: t('pos'), value: data.pos_name },
					{ label: t('from_warehouse'), value: data.wms_name },
					{ label: t('external_pos'), value: data.to_pos_name },
					{ label: t('external_wms'), value: data.to_wms_name },
					{ label: t('note'), value: data.note },
				]}
				columns={[
					{ label: t('name2'), width: '42%', numbered: true, render: (item) => item.name },
					{ label: t('quantity'), width: '16%', align: 'end', render: (item) => formatMoney(item.quantity, 2) },
					{ label: t('sale_price'), width: '20%', align: 'end', render: (item) => formatMoney(item.sale_price) },
					{ label: t('amount'), width: '22%', align: 'end', render: (item) => formatMoney(item.quantity * item.sale_price) },
				]}
				rows={data?.items || []}
				rowClassName={(item) => item.status === -1 ? 'del' : ''}
				total={[t('total'), formatMoney(data?.overall_quantity), '', formatMoney(data.overall_amount)]}
			/>
		</>
	)
}

export default Index
